__turbopack_context__.v({
  "asmodian": "PRJ3Kq_asmodian",
  "bar": "PRJ3Kq_bar",
  "breakdownBtn": "PRJ3Kq_breakdownBtn",
  "breakdownItem": "PRJ3Kq_breakdownItem",
  "breakdownList": "PRJ3Kq_breakdownList",
  "elyos": "PRJ3Kq_elyos",
  "identity": "PRJ3Kq_identity",
  "inner": "PRJ3Kq_inner",
  "left": "PRJ3Kq_left",
  "nameLink": "PRJ3Kq_nameLink",
  "pts": "PRJ3Kq_pts",
  "ptsLabel": "PRJ3Kq_ptsLabel",
  "ptsValue": "PRJ3Kq_ptsValue",
  "rank": "PRJ3Kq_rank",
  "role": "PRJ3Kq_role",
  "row": "PRJ3Kq_row",
  "stat": "PRJ3Kq_stat",
  "statLabel": "PRJ3Kq_statLabel",
  "statValue": "PRJ3Kq_statValue",
  "stats": "PRJ3Kq_stats",
});
